import axios from 'axios';
import { store } from '../store';

// Request interceptor to automatically add Authorization token
axios.interceptors.request.use(
    (config) => {
        // If authorization header is not set, try to get from redux store
        if (!config.headers.Authorization) {
            const state = store.getState();
            const studentToken =
                state.auth?.userToken?.token || state.auth?.userToken;
            const instructorToken =
                state.auth?.userToken?.token ||
                state.auth?.userToken;

            // Prioritize instructor token or student token depending on what is available
            const token = studentToken || instructorToken;
            if (token) {
                config.headers.Authorization = token;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
